import React from "react";
import { Link } from "redux-little-router";
import FollowToggleButton from "../FollowToggleButton";
import {constructUserProfilePath} from "../../util";
import "./index.css";

const UserFollowCard = props => {
  const { id, name, picture, isFollowed} = props.user;
  const profilePath = constructUserProfilePath(props.user);
  return (
    <article className="connection-wrapper">
      <Link href={profilePath}>
        <img src={picture} alt="User Name" className="-user-img" />
      </Link>
      <div className="-user-data">
        <Link href={profilePath}>{name}</Link>
      </div>
      <FollowToggleButton userId={id} isFollowed={isFollowed} />
    </article>
  );
};

export default UserFollowCard;



// WEBPACK FOOTER //
// ./src/components/UserFollowCard/index.js